import { ArticleTable } from 'ui/components/2-molecules/Article/ArticleTable';
import { Container } from 'ui/components/4-habitats/Container';

export const TableFeature: React.FC<Content.Table> = ({ content }) => (
	<Container section width="std">
		<ArticleTable {...content?.properties} />
	</Container>
);
